<div class="notification mat-elevation-z3">
    <mat-icon>info</mat-icon>
    <div style="display: flex; justify-content: center;align-items: center;">
        <h3 class="m-0 p-0"> El proceso de pago de su empresa se encuentra pendiente, esto puede ocasionar la suspensión del servicio. </h3>
    </div>
</div>
